import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { HelpModalInfo } from 'Angular/features/components/modals/help-modal/interfaces/help-modal-info.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class HelpModalService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getHelpPopup(internalName: string): Observable<HelpModalInfo> {
        const urlParams = { internalName };
        const url = this.urlsService.getUrl(this.urlsService.SUPPORT.HELP_POPUP, urlParams);
        return this.ajaxService.getDataObserveBody<HelpModalInfo>(url);
    }
}
